'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _RouterActions = require('../../../core/actions/RouterActions');

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _appStepRoutes2 = _interopRequireDefault(_appStepRoutes);

var _Lazy = require('../../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surveySteps = function surveySteps() {
  var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _appStepRoutes2.default.JOIN_HUBSPOT_EMPLOYEE;
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (props) {
    return _react2.default.createElement(
      _react2.default.Suspense,
      { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
      _react2.default.createElement(_Lazy.EmployeeRegistration, props)
    );
  };
  var stepNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var otherProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return {
    route: route,
    handler: handler,
    props: _extends({
      handleSubmit: _RouterActions.goToStep.bind(null, _appStepRoutes2.default.GETTING_STARTED),
      handleAuthError: _RouterActions.goToStep.bind(null, _appStepRoutes2.default.JOIN_HUBSPOT_ACCOUNT)
    }, otherProps),
    stepNumber: stepNumber,
    allowsRedirect: true
  };
};

exports.default = surveySteps;
module.exports = exports['default'];